module.exports = __webpack_public_path__ + "img/7.bd452fe8.jpg";